import { z } from 'zod';
import { RoleSchema } from './role.js';

export const UserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  full_name: z.string().min(1).max(200),
  role: RoleSchema,
  tenants: z.array(z.string().uuid()).min(1),
  active_tenant_id: z.string().uuid(),
  active_business_id: z.string().uuid().nullable(),
  created_at: z.string().datetime(),
  last_login_at: z.string().datetime().nullable(),
  mfa_enabled: z.boolean().default(false),
});
export type User = z.infer<typeof UserSchema>;

export const JwtClaimsSchema = z.object({
  sub: z.string().uuid(),
  email: z.string().email(),
  role: RoleSchema,
  tenant_id: z.string().uuid(),
  tenants: z.array(z.string().uuid()),
  active_business_id: z.string().uuid().nullable().optional(),
});
export type JwtClaims = z.infer<typeof JwtClaimsSchema>;
